// context/SelectedFileContext.js
import React, { createContext, useContext, useState } from 'react';

const SelectedFileContext = createContext();

export const SelectedFileProvider = ({ children }) => {
  const [selectedFile, setSelectedFile] = useState('');
  const [uploadedFileDetails, setUploadedFileDetails] = useState([]);

  const addUploadedFileDetails = ({ fileName, data }) => {
    setUploadedFileDetails(prev => {
      const filtered = prev.filter(f => f.fileName !== fileName);
      return [...filtered, { fileName, data }];
    });
  };

  return (
    <SelectedFileContext.Provider value={{ selectedFile, setSelectedFile, uploadedFileDetails, addUploadedFileDetails }}>
      {children}
    </SelectedFileContext.Provider>
  );
};

export const useSelectedFile = () => useContext(SelectedFileContext);
